<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div class="left" style="line-height: 1">证件管理系统</div>
      <el-button type="danger" @click="logout" size="mini">退出</el-button>
    </el-header>
    <!-- 主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'
      ">
        <!-- 侧边栏菜单区域 -->
        <el-menu background-color="#333744" text-color=" #fff" active-text-color="#409eff"
          unique-opened :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath">
          <el-menu-item index="/">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-menu-item index="/certificate">
            <i class="el-icon-document"></i>
            <span slot="title">证件管理</span>
          </el-menu-item>
          <el-menu-item index="/fieldConfig">
            <i class="el-icon-folder-opened"></i>
            <span slot="title">自定义配置</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      // 侧边栏导航
      menulist: [],
      //   是否折叠
      isCollapse: false,
      //   被激活的连接地址
      activePath: ""
    };
  },
  methods: {
    logout() {
      this.$message.success('退出成功');
      this.$router.push("/login");
      localStorage.clear();
    }
  },
  watch: {
    '$route.path': {
      handler (value) {
        console.log(value)
        this.activePath = value
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
  height: 100%;
}

.el-header {
  display: flex;
  background-color: rgb(51, 55, 68);
  justify-content: space-between;
  align-items: center;
  padding-left: 0;

  .left {
    color: #fff;
    font-size: 26px;
    margin-left: 20px;
  }
}

.home-logo {
  display: flex;
  margin-left: 5px;
  align-items: center;
}

.home-logo img {
  height: 50px;
}

.el-aside {
  background-color: #393d49;
  position: relative;
  z-index: 999;
}

@media screen and (min-width: 1200px) {
  .el-menu {
    height: 108%;
  }
}

@media screen and (min-width: 500px) and (max-width: 1200px) {
  .el-menu {
    height: 114%;
  }
}

.el-menu {
  border-right: none;
  overflow-y: auto;
}

.home-container .el-main {
  background-color: #eaedf1;
  height: calc(100vh - 60px);
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background: transparent;
}

.el-menu.common {
  height: calc(100% - 24px);
}

.iconfont {
  margin-right: 15px;
}

.toggle-button {
  background: #323844;
  color: white;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
  font-size: 10px;
  border: 0;
  line-height: 24px;
}

.el-tooltip {
  border: 0;
  outline: 0;
}

@media screen and (max-width: 500px) {
  .home-container .el-aside {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.65;
    width: 64px;
    transition: width 0.3s, opacity 0.3s;
    z-index: 999;
    height: 100vh;
  }

  .home-container .el-aside.isopacity {
    opacity: 1;
    width: 200px;
  }

  .el-header .el-icon-s-unfold {
    font-size: 0.8rem;
    color: #fff;
    margin-left: 0.5rem;
  }

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.45);
    width: 100vw;
    height: 100vh;
    z-index: 888;
  }

  .el-menu {
    height: 100vh;
  }

  .el-menu-item {
    height: 58px;
    line-height: 54px;
    list-style: none;
    position: relative;
    white-space: nowrap;
  }

  .home-container .el-submenu__title {
    height: 58px;
  }

  .logo {
    height: 60px;
    line-height: 60px;
    background-color: #191a23;
    border-bottom: 1px solid #393d49;
  }

  .logo img {
    width: 100%;
    vertical-align: middle;
  }
}

@media screen and (max-width: 320px) {
  .el-menu {
    height: 160vh;
  }
}
</style>
